import { zeroPad } from 'react-countdown';
import { UAParser } from 'ua-parser-js';
import canAutoPlay from 'can-autoplay';
import './logger';
import { ACCESS_STATE, AUTO_PLAY_BEHAVIOUR } from '../constants';

import VideoElement from './video-element';

const parser = new UAParser();
const parserResult = parser.getResult();

export function parseJwt(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );

  return JSON.parse(jsonPayload);
}

export const noop = (...args) => {};

export function domainResolve(url) {
  return url.replace('http://', '//').replace('https://', '//');
}

export function loadJs(url, options = {}) {
  return new Promise(function (resolve, reject) {
    const scriptTag = document.createElement('script');
    const head = document.getElementsByTagName('head')[0];
    scriptTag.src = domainResolve(url);
    scriptTag.async = options.async || true;
    scriptTag.id = options.nodeId || '';
    scriptTag.addEventListener('load', function () {
      resolve();
    });
    scriptTag.addEventListener('error', function () {
      reject(new Error('JS load failed'));
    });
    head.appendChild(scriptTag);
  });
}

export function getCleanTime(timeStampMS) {
  const weekDayList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'];
  const monthList = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  let timeLength = ('' + timeStampMS).length;
  if (timeLength === 10) {
    timeStampMS = timeStampMS * 1000;
  }
  let eventDate = new Date(timeStampMS);
  let day = weekDayList[eventDate.getDay()];
  let month = monthList[eventDate.getMonth()];
  let date = eventDate.getDate();
  let year = eventDate.getFullYear();
  let startHours = eventDate.getHours();
  let startMinutes = eventDate.getMinutes();
  let startSec = eventDate.getSeconds();
  const ampm = startHours >= 12 ? 'PM' : 'AM';
  startHours = startHours % 12;
  startHours = startHours ? startHours : 12;
  const minute = startMinutes < 10 ? '0' + startMinutes : startMinutes;
  const hour = startHours < 10 ? '0' + startHours : startHours;
  const sec = startSec < 10 ? '0' + startSec : startSec;
  let retObj = { day, year, month, date, sec, minute, hour, ampm };
  return retObj;
}

export function getTimeString(startTime) {
  const startTimeObj = getCleanTime(startTime);
  let endTimeString = '';
  let startTimeString = '';
  const day = startTimeObj.day;
  const month = startTimeObj.month;
  const date = startTimeObj.date;
  const year = startTimeObj.year;
  const startHoursStr = startTimeObj.hour;
  const startMinutesStr = startTimeObj.minute;
  const startMeridian = startTimeObj.ampm;
  // startTimeString = `${day}, ${month} ${date}, ${year}${space}${startHoursStr}:${startMinutesStr} ${startMeridian}`;
  // return startTimeString + endTimeString;

  const ddmmyyString = `${day}, ${month} ${date}, ${year}`;
  startTimeString = `${startHoursStr}:${startMinutesStr} ${startMeridian}`;
  return (
    <>
      <span>{ddmmyyString}</span>
      {startTimeString + endTimeString}
    </>
  );
}

export function isSamsungInternet() {
  return navigator.userAgent && navigator.userAgent.toLowerCase().indexOf('samsungbrowser') > -1;
}

export function getDummyMp4() {
  const DUMMY_MP4 = '//videoplayer.indiatimes.com/v2/assets/dummymp4.mp4';
  if (isSamsungInternet()) {
    return DUMMY_MP4;
  }
  // prettier-ignore
  const blob = new Blob([new Uint8Array([0, 0, 0, 28, 102, 116, 121, 112, 105, 115, 111, 109, 0, 0, 2, 0, 105, 115, 111, 109, 105, 115, 111, 50, 109, 112, 52, 49, 0, 0, 0, 8, 102, 114, 101, 101, 0, 0, 2, 239, 109, 100, 97, 116, 33, 16, 5, 32, 164, 27, 255, 192, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 55, 167, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 112, 33, 16, 5, 32, 164, 27, 255, 192, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 55, 167, 128, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 112, 0, 0, 2, 194, 109, 111, 111, 118, 0, 0, 0, 108, 109, 118, 104, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 232, 0, 0, 0, 47, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 64, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 1, 236, 116, 114, 97, 107, 0, 0, 0, 92, 116, 107, 104, 100, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 47, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 64, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 36, 101, 100, 116, 115, 0, 0, 0, 28, 101, 108, 115, 116, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 47, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 100, 109, 100, 105, 97, 0, 0, 0, 32, 109, 100, 104, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 172, 68, 0, 0, 8, 0, 85, 196, 0, 0, 0, 0, 0, 45, 104, 100, 108, 114, 0, 0, 0, 0, 0, 0, 0, 0, 115, 111, 117, 110, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 83, 111, 117, 110, 100, 72, 97, 110, 100, 108, 101, 114, 0, 0, 0, 1, 15, 109, 105, 110, 102, 0, 0, 0, 16, 115, 109, 104, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 36, 100, 105, 110, 102, 0, 0, 0, 28, 100, 114, 101, 102, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 12, 117, 114, 108, 32, 0, 0, 0, 1, 0, 0, 0, 211, 115, 116, 98, 108, 0, 0, 0, 103, 115, 116, 115, 100, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 87, 109, 112, 52, 97, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 16, 0, 0, 0, 0, 172, 68, 0, 0, 0, 0, 0, 51, 101, 115, 100, 115, 0, 0, 0, 0, 3, 128, 128, 128, 34, 0, 2, 0, 4, 128, 128, 128, 20, 64, 21, 0, 0, 0, 0, 1, 244, 0, 0, 1, 243, 249, 5, 128, 128, 128, 2, 18, 16, 6, 128, 128, 128, 1, 2, 0, 0, 0, 24, 115, 116, 116, 115, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 2, 0, 0, 4, 0, 0, 0, 0, 28, 115, 116, 115, 99, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 2, 0, 0, 0, 1, 0, 0, 0, 28, 115, 116, 115, 122, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 1, 115, 0, 0, 1, 116, 0, 0, 0, 20, 115, 116, 99, 111, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 44, 0, 0, 0, 98, 117, 100, 116, 97, 0, 0, 0, 90, 109, 101, 116, 97, 0, 0, 0, 0, 0, 0, 0, 33, 104, 100, 108, 114, 0, 0, 0, 0, 0, 0, 0, 0, 109, 100, 105, 114, 97, 112, 112, 108, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 45, 105, 108, 115, 116, 0, 0, 0, 37, 169, 116, 111, 111, 0, 0, 0, 29, 100, 97, 116, 97, 0, 0, 0, 1, 0, 0, 0, 0, 76, 97, 118, 102, 53, 54, 46, 52, 48, 46, 49, 48, 49])
  ],
    {
      type: 'video/mp4'
    }
  );
  if (URL && typeof URL.createObjectURL === 'function') {
    return URL.createObjectURL(blob);
  } else {
    return DUMMY_MP4;
  }
}

export function captureScreenShot(source) {
  try {
    if (source instanceof HTMLVideoElement) {
      if (source.videoHeight === 0 || source.videoWidth === 0) {
        return null;
      }
      let canvas = document.createElement('canvas');
      canvas.height = source.videoHeight;
      canvas.width = source.videoWidth;
      let context = canvas.getContext('2d');
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.drawImage(source, 0, 0, canvas.width, canvas.height);
      return canvas.toDataURL('image/png', 1.0);
    } else if (source instanceof HTMLCanvasElement) {
      return source.height === 0 || source.width === 0 ? null : source.toDataURL('image/png', 1.0);
    }
  } catch (err) {
    console.error('error in capture screenshot', err);
  }
  return null;
}

export function humanReadableNumber(x) {
  var postfix = ['', 'K', 'M', 'B'];
  var len = String(Math.round(x)).length;
  var div = Math.floor(len / 3);
  var remainder = len % 3;
  if (remainder === 0) {
    remainder = 3;
    div = div - 1;
  }
  var pow = 3 - remainder;
  var newNum = x / Math.pow(10, div * 3);
  newNum = Math.round(newNum * Math.pow(10, pow)) / Math.pow(10, pow);
  return newNum + postfix[div];
}

export function secondsToHms(d) {
  d = Number(d);
  var h = Math.floor(d / 3600);
  var m = Math.floor((d % 3600) / 60);
  var s = Math.floor((d % 3600) % 60);

  var hDisplay = h > 0 ? zeroPad(h) + ':' : '00:';
  var mDisplay = m > 0 ? zeroPad(m) + ':' : '00:';
  var sDisplay = s > 0 ? zeroPad(s) + '' : '00';
  return hDisplay + mDisplay + sDisplay;
}

export function secondsToMs(d) {
  d = Number(d);
  var h = Math.floor(d / 3600);
  var m = Math.floor((d % 3600) / 60);
  var s = Math.floor((d % 3600) % 60);
  var hDisplay = h > 0 ? zeroPad(h) + ':' : '';
  var mDisplay = m > 0 ? zeroPad(m) + ':' : '00:';
  var sDisplay = s > 0 ? zeroPad(s) + '' : '00';
  return hDisplay + mDisplay + sDisplay;
}

export function getOrientation() {
  const Ios = isIosDevice();
  const IsIframe = checkInIframe();
  const innerWidth = Ios || IsIframe ? document.body.clientWidth : window.screen.width;
  const innerHeight = Ios || IsIframe ? document.body.clientHeight : window.screen.height;
  if (innerHeight > innerWidth) {
    return 'portrait';
  } else {
    return 'landscape';
  }
}

export function isSWSupported() {
  if ('serviceWorker' in navigator) {
    return true;
  }
  return false;
}

export function makeId(length) {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function copyText(text, cb, element) {
  let parentEl = element ? element : document.body;
  try {
    var textarea = document.createElement('textarea');
    parentEl.appendChild(textarea);
    textarea.value = text;
    textarea.focus();
    textarea.select();
    document.execCommand('copy');
    parentEl.removeChild(textarea);
    cb(true);
  } catch (e) {
    parentEl.removeChild(textarea);
    cb(false);
  }
}

export function isScreenshotSupported() {
  let browserName = parserResult.browser?.name?.toLowerCase();
  let deviceType = parserResult.device?.type?.toLowerCase();
  let os = parserResult.os?.name?.toLowerCase();
  if (os && os.indexOf('mac') !== -1 && browserName && browserName.indexOf('safari') !== -1) {
    return false;
  }
  if (deviceType === 'mobile' && browserName === 'firefox') {
    return false;
  }
  return true;
}

export function deviceBrowserName() {
  let browserName = parserResult.browser?.name?.toLowerCase();
  let deviceType;
  var ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    deviceType = 'tablet';
  }
  if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
    deviceType = 'mweb';
  } else {
    deviceType = 'desktop';
  }
  return deviceType + '_' + browserName;
}

export function isIosDevice() {
  var ua = navigator.userAgent;
  if (ua.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
    return true;
  }
  if (/iPad|iPhone|iPod/.test(ua)) {
    return true;
  }
  return false;
}

export function getNetworkInfo() {
  if (navigator && navigator.connection) {
    const result = {
      type: navigator.connection.type,
    };
    const effectiveType = navigator.connection.effectiveType;
    if (effectiveType) {
      result.effectiveType = effectiveType;
    }
    return result;
  }
  return {
    type: 'NA',
    effectiveType: 'NA',
  };
}

export function wait(time) {
  return new Promise((resolve) => {
    setTimeout(resolve, time);
  });
}

export function getFolderShardedPath(eventID) {
  if (eventID.length < 7) {
    return eventID;
  }
  return eventID.substring(2, 4) + '/' + eventID.substring(4, 6) + '/' + eventID;
}

// export async function checkAutoPlay(config = {}) {
//   try {
//     const response = await canAutoPlay.video({ timeout: 100, ...config });
//     if (response) {
//       return response.result;
//     }
//   } catch (err) {
//     console.error('checkAutoPlay', err);
//   }
//   return false;
// }

export async function checkAutoPlay(config) {
  const fallBackMute = config.muted;
  return new Promise((resolve, reject) => {
    const videoEl = new VideoElement();
    videoEl.canAutoPlay((autoPlay, muted) => {
      if (autoPlay) {
        if (muted) {
          resolve(AUTO_PLAY_BEHAVIOUR.WITHOUT_SOUND);
          return;
        }
        resolve(AUTO_PLAY_BEHAVIOUR.ALLOW);
      } else {
        resolve(AUTO_PLAY_BEHAVIOUR.NEVER);
      }
    }, fallBackMute);
  });
}

export function toDataURL(url, callback) {
  var xhr = new XMLHttpRequest();
  xhr.onload = function () {
    var reader = new FileReader();
    reader.onloadend = function () {
      callback(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open('GET', url);
  xhr.responseType = 'blob';
  xhr.send();
}

export function evalValue(value, defaultValue) {
  if (typeof value === 'undefined') {
    return defaultValue;
  }
  return value;
}

export function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function callWebviewController(method, data) {
  if (window.JSContext && typeof window.JSContext[method] === 'function') {
    try {
      const response = window.JSContext[method](JSON.stringify(data));
      return response;
    } catch (err) {
      console.error('Error in JSContext', err);
    }
  }
}
export function checkInIframe() {
  if (window.location !== window.parent.location) {
    return true;
  }
  return false;
}

export function getParentDomain() {
  let parentDomain = '';
  parentDomain = document.referrer;
  if (parentDomain === '') {
    try {
      parentDomain = window.top.location.hostname;
    } catch (error) {
      let ancestorOrigin = document.location.ancestorOrigins;
      if (ancestorOrigin && ancestorOrigin.length > 0) {
        parentDomain = ancestorOrigin[0];
        parentDomain = cleanParentDomain(parentDomain);
      }
    }
  } else {
    parentDomain = cleanParentDomain(parentDomain);
    if (parentDomain[parentDomain.length] === '/') {
      parentDomain = parentDomain.substring(0, parentDomain.length - 1);
    }
  }
  return parentDomain;
}

export function cleanParentDomain(parentDomain) {
  if (parentDomain.includes('https://')) {
    parentDomain = parentDomain.replace('https://', '');
  }
  if (parentDomain.includes('http://')) {
    parentDomain = parentDomain.replace('http://', '');
  }
  return parentDomain;
}

export function checkDomainConfiguration(apiKeyJson) {
  var domains = [...(apiKeyJson.conf?.global?.domains ?? [])];
  if (domains && domains.length !== 0 && checkInIframe()) {
    try {
      var parentDomain = getParentDomain();
    } catch (err) {
      return false;
    }
    if (
      parentDomain.includes('localhost') ||
      domains.includes('') ||
      domains.includes(parentDomain) ||
      domains.includes('.*')
    ) {
      return true;
    } else {
      if (domains.length === 1 && domains[0] === '*') {
        return true;
      } else {
        for (let i = 0; i < domains.length; i++) {
          let tm = domains[i].split('.');
          if (tm[0] === '*') {
            if (tm.length > 2) {
              let dm = tm[1] + '.' + tm[2];
              if (parentDomain.indexOf(dm) !== -1) {
                return true;
              }
            }
          }
        }
      }
    }
    return false;
  }
  return true;
}

export function hasNotValue(val) {
  if (typeof val === 'undefined' || val === null) {
    return true;
  }
  return false;
}

export function isImageGif(url) {
  return url.substring(url.length - 3) === 'gif';
}

export function isCamMicAccess(cb) {
  let browserName = parserResult.browser?.name?.toLowerCase();
  if (browserName === 'firefox') {
    cb(ACCESS_STATE.GIVEN);
    return;
  }
  navigator.permissions.query({ name: 'camera' }).then((result) => {
    if (result.state === 'granted') {
      navigator.permissions.query({ name: 'microphone' }).then((result) => {
        if (result.state === 'granted') {
          cb(ACCESS_STATE.GIVEN);
        } else if (result.state === 'prompt') {
          cb(ACCESS_STATE.CAN_ASK);
        } else {
          cb(ACCESS_STATE.BLOCKED);
        }
      });
    } else if (result.state === 'prompt') {
      cb(ACCESS_STATE.CAN_ASK);
    } else {
      cb(ACCESS_STATE.BLOCKED);
    }
  });
}

export function tryParseJSONObject(jsonString) {
  try {
    const o = JSON.parse(jsonString);

    // Handle non-exception-throwing cases:
    // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
    // but... JSON.parse(null) returns null, and typeof null === "object",
    // so we must check for that, too. Thankfully, null is falsey, so this suffices:
    if (o && typeof o === 'object') {
      return o;
    }
  } catch (e) {}

  return undefined;
}

export function parseForEmojis(textMessage) {
  let regexp;
  try {
    regexp = new RegExp('\\p{Emoji}', 'gu');
  } catch (e) {
    //4 firefox <3
    regexp = new RegExp(
      `(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])`,
      'g',
    );
  }

  textMessage = textMessage.replace(regexp, (e) => {
    // eslint-disable-next-line no-useless-escape
    const reg = /^[0-9!@#\$%\^\&*\)\(+=._-]+$/g;
    if (reg.exec(e)) return e;
    return `<span class="emojiSpan">${e}</span>`;
  });
  return textMessage;
}

export const AddLinkToMsg = (message) => {
  const msg = message;
  const regex = /(((https?:\/\/)|(www\.))[^\s]+)/g;

  const msg1 = msg.replace(regex, function (x) {
    const originalUrl = x;
    if (!x.match(/^https?:\/\//i)) {
      x = 'https://' + x;
    }
    return '<a href="' + x + '" target="_blank">' + originalUrl + '</a>';
  });
  return msg1;
};

export const PrepareSimuliveUrl = (baseUrl, uri) => {
  if (uri.startsWith('http')) return uri;
  return `${baseUrl}${uri}`;
};

export const getCurrentMediaForSimulive = (playlistData, loopPlaylist, relativeTimeDiff = 0) => {
  //check for live media
  for (let index = 0; index < playlistData.order.length; index++) {
    let media = playlistData.items[playlistData.order[index]];
    if (media.type === 3) {
      return {
        ...media,
        head: playlistData.head,
        seek: 0,
        hls: media.hls,
        dur: media.dur,
        id: playlistData.order[playlistData.head],
      };
    }
  }

  let mediaData = {};
  let totalPlDur = 0;
  let elapsedTime = Date.now() - relativeTimeDiff - playlistData.ts;
  if (playlistData?.order?.length > 0) {
    playlistData.order.forEach((element) => {
      totalPlDur += playlistData.items[element].dur;
    });
  }
  if (totalPlDur !== 0 && elapsedTime > totalPlDur) {
    elapsedTime = elapsedTime % totalPlDur;
  }
  let total = 0;
  let found = false;
  for (let index = playlistData.head; index < playlistData.order.length; index++) {
    let media = playlistData.items[playlistData.order[index]];
    total = total + media.dur;
    if (total > elapsedTime) {
      found = true;
      mediaData = {
        ...mediaData,
        head: index,
        seek: media.dur - (total - elapsedTime),
        hls: media.hls,
        dur: media.dur,
        id: playlistData.order[index],
      };
      break;
    }
  }

  //iterate from Oth index if loop enabled and still index not found
  if (!found && elapsedTime > total && loopPlaylist) {
    for (let index = 0; index <= playlistData.head; index++) {
      let media = playlistData.items[playlistData.order[index]];
      total = total + media.dur;
      if (total > elapsedTime) {
        found = true;
        mediaData = {
          ...mediaData,
          head: index,
          seek: media.dur - (total - elapsedTime),
          hls: media.hls,
          dur: media.dur,
          id: playlistData.order[index],
        };
        break;
      }
    }
  }
  return mediaData;
};
